import React from "react";
import { OrderDetail } from "./OrderDetail";

export function OrderDetailContainer() {
  return <OrderDetail />;
}

